import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from "react-router-dom";
import 'primereact/resources/themes/nova-accent/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { Card } from "primereact/card";
import { Modal, Col, Row, Form, Button as ReactButton } from 'react-bootstrap';
import { handleRequest } from '../../redux/config/env';
import { FormattedMessage } from "react-intl";
import 'react-contexify/dist/ReactContexify.min.css';
import { Item, MenuProvider } from 'react-contexify';
import CustomMaterialMenuDelete from '../settings/ForComponents/CustomMaterialMenuDelete';
import HowtoUse from '../standardization/HowtoUse';
import Settings from '../standardization/Settings';
import Whatis from '../standardization/Whatis';
import { Table, Input } from 'antd';
//import QrReader from 'react-qr-scanner';
import QrReader from 'react-qr-reader';
import { setStandardization, getDynamicMenu, getUserSettings } from '../../redux/config/imu.js';

const pageName = "TimelineQRSetting";

export class TimelineQRSetting extends Component {

    constructor() {
        super();
        this.state = {
            modalDeleteShow: false,
            hideInputs: true,
            qrCodeList: [],
            qrCodeSettingList: [],
            qrCodeId: 0,

            delay: 500,
            result: "",

            columns: [
                {
                    key: "key",
                    title: "Action",
                    render: (value, row, index) => {
                        return this.actionTemplate(row);
                    }
                },
                {
                    key: "qrCodeData",
                    title: "QR Code",
                    dataIndex: "qrCodeData"
                },
                {
                    key: "qrCodeSettingDate",
                    title: "Date, time",
                    dataIndex: "qrCodeSettingDate"
                },
                {
                    key: "coordinates",
                    title: "Coordinates",
                    render: (data) => {
                        if (data != null && data != undefined) {
                            return "Lat: " + data.latitude + " / " + "Long: " + data.longitude;
                        }
                        return "";
                    }
                },
                {
                    key: "location",
                    title: "Location",
                    dataIndex: "location"
                }
            ],

            authorizations: [],
            dynamicInputs: [],
            isAdmin: false,
            howToUseSetting: false,
            whatIsSetting: false,
            dynamicAttributes: [],
            formId: 0
        };
    }

    formRef = React.createRef();

    componentDidMount = async () => {
        var isAdmin = false;
        let dynamicMenu = await getDynamicMenu(pageName);
        this.getUserSettings(dynamicMenu.formId);
        if (Boolean(this.props.auth) && Boolean(this.props.auth.user) && this.props.auth.user.userType === 2) {
            isAdmin = true;
        }

        let standardization = await setStandardization(pageName);
        this.setState({
            dynamicAttributes: standardization.dynamicAttributes,
            dynamicInputs: standardization.dynamicInputs,
            isAdmin: isAdmin,
            formId: dynamicMenu.formId,
            authorizations: dynamicMenu.authorizations
        });

        this.restartTable();
        this.testLocation();
    }

    getUserSettings = async (formId) => {
        let userSettings = await getUserSettings(formId);
        this.setState(
            {
                howToUseSetting: userSettings.howToUseSetting,
                whatIsSetting: userSettings.whatIsSetting
            }
        )
    }

    testLocation = async () => {
        if (navigator.geolocation) {
            const successCallback = async (position) => {
                this.setState({
                    latitude: position.coords.latitude.toString(),
                    longitude: position.coords.longitude.toString()
                });
                console.log(position);
            };

            const errorCallback = (error) => {
                this.setState({
                    latitude: "",
                    longitude: ""
                });
                console.error(error);
            };

            navigator.geolocation.getCurrentPosition(successCallback, errorCallback);
        } else {
            this.setState({
                latitude: "",
                longitude: ""
            });
        }
    }

    save = async () => {
        let _today = new Date();
        var HH = String(_today.getHours()).padStart(2, '0');
        var minute = String(_today.getMinutes()).padStart(2, '0');
        var dd = String(_today.getDate()).padStart(2, '0');
        var mm = String(_today.getMonth() + 1).padStart(2, '0');
        var yyyy = _today.getFullYear();

        let today = dd + '/' + mm + '/' + yyyy + ' ' + HH + ':' + minute;

        const obj = {
            qrCodeId: this.state.qrCodeId,
            qrCodeData: this.state.result,
            qrCodeSettingDate: today,
            latitude: this.state.latitude,
            longitude: this.state.longitude,
            location: this.state.location,
            scannedById: this.props.auth.user.id
        }

        var responseAdd = await handleRequest("POST", "/TimelineQRSetting/add", obj);
        if (responseAdd.data !== null && responseAdd.data !== undefined) {
            if (responseAdd.data === "SUCCESS") {
                this.resetInputs();
                this.showSuccess();
                this.restartTable();
            }
            else {
                this.showError();
            }
        }
    }

    delete = async () => {
        const obj = {
            id: this.state.qrId
        };
        await handleRequest("POST", "/TimelineQRSetting/delete", obj);
        this.restartTable();
        this.showSuccess();
        this.showOrHideDeleteModal();
    }

    deleteModal = (row) => {
        this.setState({
            modalDeleteShow: true,
            qrId: row.id
        });
    }

    showOrHideDeleteModal = () => {
        this.setState({
            modalDeleteShow: !this.state.modalDeleteShow
        });

        setTimeout(() => {
            document.body.style.overflow = "auto";
        }, 500);
    }

    showSuccess(msg) {
        if (!msg) {
            msg = <FormattedMessage id="GeneralMessageSuccess1" defaultMessage="Successful" />;
        }
        this.setState({
            modalMessage: true,
            message: msg,
            messageTip: "Success"
        });
    }

    showError(msg) {
        if (!msg) {
            msg = <FormattedMessage id="GeneralMessageError1" defaultMessage="An error was occured please try again later!" />;
        }
        this.setState({
            modalMessage: true,
            message: msg,
            messageTip: "Error"
        });
    }

    showWarning(msg) {
        if (!msg) {
            msg = <FormattedMessage id="GeneralMessageCheckInputs" defaultMessage="Something went wrong. Please check inputs." />;
        }
        this.setState({
            modalMessage: true,
            message: msg,
            messageTip: "Warning"
        });
    }

    actionTemplate(rowData, column) {
        return <React.Fragment>
            <CustomMaterialMenuDelete row={rowData} onDeleteRow={this.deleteModal.bind(this)} />
        </React.Fragment>;
    }

    restartTable = async () => {
        const responseQRList = await handleRequest("GET", "/TimelineQRGenerator/getAllByCompany");

        if (responseQRList.data.length !== 0) {
            this.setState({
                qrCodeList: responseQRList.data,
            });
        }

        if (responseQRList.data.length === 0) {
            this.setState({
                qrCodeList: [],
            });
        }

        const response = await handleRequest("GET", "/TimelineQRSetting/getAllByCompany");

        if (response.data.length !== 0) {
            this.setState({
                qrCodeSettingList: response.data,
            });
        }

        if (response.data.length === 0) {
            this.setState({
                qrCodeSettingList: [],
            });
        }
    }

    createNew = () => {
        if (this.state.latitude !== "" && this.state.longitude !== "") {
            this.setState({
                qrId: 0,
                hideInputs: false,
                camera: true,
                modalDeleteShow: false
            });
        } else {
            this.testLocation();
            this.showWarning("Something went wrong. Please allow location data sharing.");
        }
    }

    stop = () => {
        this.setState({
            qrId: 0,
            modalDeleteShow: false,
            hideInputs: true
        });
    }

    resetInputs = () => {
        this.setState({
            qrId: 0,
            qrCodeId: 0,
            qrCode: "",
            qrCodeDate: "",
            location: "",
            modalDeleteShow: false,
            modalLocation: false,
            hideInputs: true
        });
    }

    edit = (row) => {
        console.log(row, "Do Nothing!");
    }

    cancel = () => {
        this.resetInputs();
    }

    showOrHideModalMessage = () => {
        this.setState({
            modalMessage: !this.state.modalMessage,
        });
        setTimeout(() => {
            document.body.style.overflow = "auto";
        }, 500);
    }

    handleScan = (data) => {
        if (data) {
            this.setState({ result: data });
            console.log(data);

            let flagQRCodeId = 0;

            for (let index = 0; index < this.state.qrCodeList.length; index++) {
                if (this.state.qrCodeList[index].qrCode === data)
                    flagQRCodeId = this.state.qrCodeList[index].id;
            }

            if (flagQRCodeId !== 0) {
                this.setState({
                    camera: false,
                    qrCodeId: flagQRCodeId,
                    hideInputs: true,
                    modalLocation: true
                });
            } else {
                this.showWarning("This QR Code is no longer valid!");
            }
        }
    }

    handleError = (err) => {
        console.error(err);
    }

    showOrHideModalLocation = () => {
        this.setState({
            modalLocation: !this.state.modalLocation,
        });
        setTimeout(() => {
            document.body.style.overflow = "auto";
        }, 500);
    }

    render() {
        //const previewStyle = { height: "500px", width: "100%" };
        const previewStyle = {
            height: 500,
            width: 500,
        }

        return (this.state.formId > 0) ? (
            (this.state.authorizations.length > 0 && this.state.authorizations.findIndex(p => p.action === "view") >= 0)
                ? (
                    <div>
                        <MenuProvider id="menu_id">

                            <Modal
                                show={this.state.modalMessage}
                                onHide={this.showOrHideModalMessage}
                                backdrop="static"
                                aria-labelledby="contained-modal-title-vcenter"
                                centered>

                                <Modal.Header closeButton>
                                    <Modal.Title id="contained-modal-title-vcenter">
                                        <Row >
                                            <Col sm="12">
                                                {this.state.messageTip == "Success" &&
                                                    <i className="fas fa-check fa-2x" style={{ color: '#00ff2a' }} />}

                                                {this.state.messageTip == "Warning" &&
                                                    <i className="fas fa-exclamation-circle fa-2x" style={{ color: '#faca2a' }} />}

                                                {this.state.messageTip == "Error" &&
                                                    <i className="fas fa-times fa-2x" style={{ color: '#ff0400' }} />}
                                            </Col>
                                        </Row>
                                    </Modal.Title>
                                </Modal.Header>

                                <Modal.Body>
                                    <Row >
                                        <Col sm="12">
                                            {this.state.message}
                                        </Col>
                                    </Row>
                                </Modal.Body>
                                <Modal.Footer>
                                    <ReactButton variant="secondary" onClick={this.showOrHideModalMessage}><FormattedMessage id="GeneralTextClose" defaultMessage="Close" /></ReactButton>
                                </Modal.Footer>
                            </Modal>

                            <Modal
                                show={this.state.modalDeleteShow}
                                onHide={this.showOrHideDeleteModal}
                                aria-labelledby="contained-modal-title-vcenter"
                                centered
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title id="contained-modal-title-vcenter">Chosen status will be deleted!</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <p>Are you sure?</p>
                                </Modal.Body>
                                <Modal.Footer>
                                    <ReactButton variant="secondary" onClick={this.showOrHideDeleteModal}>Cancel</ReactButton>
                                    <ReactButton variant="danger" onClick={this.delete} >Delete</ReactButton>
                                </Modal.Footer>
                            </Modal>

                            <Modal
                                show={this.state.modalLocation}
                                onHide={this.showOrHideModalLocation}
                                backdrop="static"
                                aria-labelledby="contained-modal-title-vcenter"
                                centered>
                                <Modal.Header style={{ backgroundColor: "#f3f3f3" }} closeButton>
                                    <Modal.Title id="contained-modal-title-vcenter">
                                        <FormattedMessage id="TimelineQRSettingSetLocation" defaultMessage="Set Location" />
                                    </Modal.Title>
                                </Modal.Header>

                                <Modal.Body style={{ backgroundColor: "#f3f3f3" }}>
                                    <Form>
                                        <Row style={{ marginBottom: '1rem' }}>
                                            <Col xs={4}>
                                                <Form.Label style={{ color: "black", marginTop: "0.5rem", fontWeight: "bold" }}>
                                                    <FormattedMessage id="TimelineQRSettingLatitude" defaultMessage="Latitude: " />
                                                </Form.Label>
                                            </Col>
                                            <Col xs={8}>
                                                <Input id="TimelineQRSettingLatitude" value={this.state.latitude} />
                                            </Col>
                                        </Row>

                                        <Row style={{ marginBottom: '1rem' }}>
                                            <Col xs={4}>
                                                <Form.Label style={{ color: "black", marginTop: "0.5rem", fontWeight: "bold" }}>
                                                    <FormattedMessage id="TimelineQRSettingLongitude" defaultMessage="Longitude: " />
                                                </Form.Label>
                                            </Col>
                                            <Col xs={8}>
                                                <Input id="TimelineQRSettingLongitude" value={this.state.longitude} />
                                            </Col>
                                        </Row>

                                        <Row style={{ marginBottom: '1rem' }}>
                                            <Col xs={4}>
                                                <Form.Label style={{ color: "black", marginTop: "0.5rem", fontWeight: "bold" }}>
                                                    <FormattedMessage id="TimelineQRSettingLocation" defaultMessage="Location: " />
                                                </Form.Label>
                                            </Col>
                                            <Col xs={8}>
                                                <Input id="TimelineQRSettingLocation" value={this.state.location}
                                                    onChange={(e) => this.setState({ location: e.target.value })} />
                                            </Col>
                                        </Row>

                                        <Form.Group style={{ marginTop: '1rem', marginBottom: '1rem' }} as={Row}>
                                            <Col sm="12">
                                                <ReactButton style={{ width: '100%' }} onClick={this.save}>
                                                    <FormattedMessage id="GeneralTextSave" defaultMessage="Save" />
                                                </ReactButton>
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </Modal.Body>
                            </Modal>

                            <Card>

                                <div>
                                    <Row>
                                        <Col sm="1">
                                            <Settings formId={this.state.formId} onSaveChanges={this.getUserSettings.bind(this)} ></Settings>

                                        </Col>
                                        <Col sm="10">
                                        </Col>
                                        <Col sm="1" style={{ textAlign: "right" }}>
                                            {!this.state.howToUseSetting && <HowtoUse formId={this.state.formId} ></HowtoUse>}
                                        </Col>
                                    </Row>
                                </div>

                                <div>
                                    <Row>
                                        <Col sm="10">
                                        </Col>
                                        <Col sm="2">
                                            {this.state.hideInputs &&
                                                <ReactButton id="TimelineQRSettingCreateNewButton" style={{ width: '100%', marginBottom: '2rem' }} variant="primary" onClick={this.createNew}><FormattedMessage id="GeneralButtonScan" defaultMessage="Scan" /></ReactButton>
                                            }
                                            {!this.state.hideInputs &&
                                                <ReactButton id="TimelineQRSettingCreateNewButton" style={{ width: '100%', marginBottom: '2rem' }} variant="danger" onClick={this.stop}><FormattedMessage id="GeneralButtonStopProcess" defaultMessage="Stop the Process" /></ReactButton>
                                            }
                                        </Col>
                                    </Row>
                                </div>

                                <div hidden={this.state.hideInputs} style={{ marginBottom: '1rem' }}>
                                    <Row>
                                        <Col sm="1">
                                        </Col>
                                        <Col sm="10">
                                            {this.state.camera && <QrReader
                                                ref="qrReader1"
                                                delay={this.state.delay}
                                                style={{ height: 300, width: 300 }}
                                                onError={this.handleError}
                                                onScan={this.handleScan}
                                            />
                                            }
                                        </Col>
                                        <Col sm="1">
                                        </Col>
                                    </Row>
                                </div>

                                <Table style={{ marginTop: '3rem' }} columns={this.state.columns} dataSource={this.state.qrCodeSettingList} bordered scroll={{ x: 800, scrollToFirstRowOnChange: true }}></Table>

                            </Card>

                       </MenuProvider>
                        {!this.state.whatIsSetting && <Whatis></Whatis>}
                    </div>
                ) : (
                    <div>
                        <Redirect to="/error/error-v6" />
                    </div>
                )
        ) : (<div></div>);
    }
}

const mapStateToProps = state => {
    return {
        auth: state.auth,
        i18n: state.i18n
    }
}

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(TimelineQRSetting) 